module.exports = __webpack_public_path__ + "img/10-1-n.beeb6aa0.png";